import React from "react";

const Info = () => {
  return (
    <div className="about_info grid grid-cols-1 md:grid-cols-3 gap-6 m-6">
      <div className="about_box bg-gray-100 rounded-lg shadow-md p-6 text-center flex flex-col justify-center items-center">
        <h3 className="text-xl font-semibold text-gray-800 mb-2 flex-grow">
          Years of Experience
        </h3>
        <span className="text-lg text-blue-600 font-medium">3+</span>
      </div>

      <div className="about_box bg-gray-100 rounded-lg shadow-md p-6 text-center flex flex-col justify-center items-center">
        <h3 className="text-xl font-semibold text-gray-800 mb-2 flex-grow">
          Projects Completed
        </h3>
        <span className="text-lg text-green-600 font-medium">20+</span>
      </div>

      <div className="about_box bg-gray-100 rounded-lg shadow-md p-6 text-center flex flex-col justify-center items-center">
        <h3 className="text-xl font-semibold text-gray-800 mb-2 flex-grow">
          Availability
        </h3>
        <span className="text-lg text-yellow-600 font-medium">Flexible</span>
      </div>
    </div>
  );
};

export default Info;
